// extracted by mini-css-extract-plugin
module.exports = {"container":"Tabs_container_2lrbm","tab":"Tabs_tab_3E3Hc","label":"Tabs_label_IDbPM","selected":"Tabs_selected_3BH6j","indicator":"Tabs_indicator_1Lfn5"};